import React, { Component } from 'react';
import './Gutters.css';
import QuoteForm from '../QuoteForm/QuoteForm';
import StyleCard from '../StyleCards/StyleCard';

import { BrowserRouter as Router, Routes,Route } from 'react-router-dom';


class Gutters extends Component {
  render() {
  return (
    <div class='windowMain'>
      <div class='gutterHeader'>
        <h1 class="windowTitle">
          Gutters
        </h1>
      </div>
      <div class="visionSect">
         <h2>Gutter Replacements</h2>
         <div class="vision">
          Our Vision at DNS Home Exteriors has always been to set a new standard of excellence for contractors that raises the bar when it comes to first-class customer service, industry knowledge, and craftsmanship.
         </div>
      </div>
      <hr></hr>
      <div class="windowInfoSect">
        <section class="windowInfo">
          <div>
          <h4>It's time to replace your Gutters</h4>
          <p>Replacing your gutters is a crucial step in preventing
          water damage to your home. Over time, gutters can become
          clogged with debris, develop rust, or crack, which can lead
          to improper water flow. When gutters fail to direct water away
          from your home’s foundation, it can cause significant issues
          like basement flooding, erosion around the property, and even
          damage to siding and landscaping. A new set of gutters ensures
          that rainwater is efficiently channeled away, protecting your
          home from potential water-related damage.
          <br></br>
          <br></br>
          In addition to safeguarding your home, replacing your gutters can
          improve the overall look and value of your property. Modern gutter
           systems are available in a variety of materials and styles, offering
           both durability and aesthetic appeal. Whether you opt for seamless
            gutters or a more attractive finish, an upgrade can enhance the
            curb appeal of your home while providing peace of mind that your
            property is protected from costly water damage in the future.</p>
          </div>
        </section>
        <section class="quotoForm">
          <QuoteForm />
        </section>
      </div>
    <div class="sectionSpacer">
    </div>

  </div>
  )
};
}

export default Gutters;
